import { render } from "./InstructorDetails.vue?vue&type=template&id=faa11f7a"
import script from "./InstructorDetails.vue?vue&type=script&lang=js"
export * from "./InstructorDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__